<template>
  <label
    :class="['tab', { 'flex-1': wide, 'tab-disabled': disabled }]"
    data-sentry-unmask
  >
    <input
      type="radio"
      :name="name"
      :checked="isActive"
      :disabled="disabled"
      @change="handleChange"
    />
    <app-icon
      v-if="icon"
      :name="icon"
      size="sm"
    />
    {{ label }}
  </label>
</template>

<script setup>
import { inject, computed } from 'vue';

defineOptions({
  name: 'AppTab',
});

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: true,
  },
  wide: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
  },
});

const { name, activeTab, setActiveTab } = inject('tabs');

const isActive = computed(() => activeTab.value === props.value);

const handleChange = () => {
  if (!props.disabled && activeTab.value !== props.value) {
    setActiveTab(props.value);
  }
};
</script>
